module.exports = __webpack_public_path__ + "static/media/call_status_on_hold.68f9a694.svg";